import React, { useEffect } from "react";
import PropTypes from "prop-types";
import GuaranteedData from "./GuaranteedData";
import VerifiableData from "./VerifiableData";
import CustomerReviews from "./CustomerReviews";
import SupplementaryInformation from "./SupplementaryInformation";
import TransformDataSecurity from "./TransformDataSecurity";
import { Box } from "@mantine/core";

const Landing = ({ staticBasePath, landingSectionRef }) => {
  useEffect(() => {}, [landingSectionRef]);

  return (
    <Box ref={landingSectionRef}>
      <GuaranteedData staticBasePath={staticBasePath} />
      <VerifiableData staticBasePath={staticBasePath} />
      <CustomerReviews staticBasePath={staticBasePath} />
      <SupplementaryInformation staticBasePath={staticBasePath} />
      <TransformDataSecurity staticBasePath={staticBasePath} />
    </Box>
  );
};

Landing.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
  landingSectionRef: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
};
export default Landing;
